import { z } from 'zod/v4';
import { UserAttributeInstanceDTO } from './types';

// Типы для тестового результата OIDC
export const OIDCUserInfoDTO = z.record(z.string(), z.any());
export type OIDCUserInfo = z.infer<typeof OIDCUserInfoDTO>;

// Специальный тип пользователя для тестового результата OIDC
// В отличие от обычного User, здесь attribute_values - это массив
export const OIDCTestUserDTO = z.object({
  id: z.string(),
  name: z.string().optional(),
  surname: z.string().optional(),
  patronymic: z.string().optional(),
  login: z.string(),
  language: z.string(),
  email: z.string().optional(),
  status: z.string().optional(),
  ldap_id: z.string().uuid().nullable().optional(),
  sessions_max_count: z.number().optional(),
  is_password_expired: z.boolean().optional(),
  attribute_values: z.array(UserAttributeInstanceDTO).optional(),
});
export type OIDCTestUser = z.infer<typeof OIDCTestUserDTO>;

export const OIDCTestResultDTO = z.object({
  user: OIDCTestUserDTO.nullable(),
  user_info: OIDCUserInfoDTO,
  success: z.boolean(),
  provider: z.string(),
  error_message: z.string().nullable(),
  error_vars: z.record(z.string(), z.any()),
});
export type OIDCTestResult = z.infer<typeof OIDCTestResultDTO>;